export default __webpack_public_path__ + "static/media/L-BOT-LONG-TITLE.b9121ab7.png";